import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import type { MeterPricingTiers } from '../billing-meter/billing-meter.types';

@Component({
  selector: 'tf-billing-pricing-tiers-dialog',
  imports: [CommonModule, TranslateModule, DialogModule, TableModule, ButtonModule],
  templateUrl: './billing-pricing-tiers-dialog.html',
  styleUrl: './billing-pricing-tiers-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingPricingTiersDialog {
  readonly tiers = input<MeterPricingTiers | null>(null);
  readonly closed = output<void>();

  protected onVisibleChange(visible: boolean): void {
    if (!visible) {
      this.closed.emit();
    }
  }
}
